import loadable from '@loadable/component'
import React from 'react'
import LoadingIndicator from '../LoadingIndicator'

type IconsSize = 'SM' | 'MD' | 'LG' | 'XL'

type IOrangeDSIconProps = {
  icon: string;
  color?: string;
  size: IconsSize;
  className?: string;
}

export function IntercoIcons ({ icon = '', color = 'orange-base', size, className = ''}: IOrangeDSIconProps) {
  const SvgIcon = loadable(() => import(`@interco/icons/build-v4/orangeds/${size}/${icon}`), {
    fallback: <LoadingIndicator size='small' />
  })

  return (
    <SvgIcon color={color} size={size} className={className} />
  )
}

export default IntercoIcons
